import React from "react";
import { LocalServiceTemplate } from "@/components/local/LocalServiceTemplate";
import { localServiceData } from "@/data/localServiceData";

const ZonnepanelenDuiven = () => {
  return <LocalServiceTemplate data={localServiceData['zonnepanelen-duiven']} />;
};

export default ZonnepanelenDuiven;